import { useState } from "react";
import { PageTitle } from "./PageTitle";
import { validateEmail } from "../helpers/helpers";
import { addFollower } from "../hooks/addFollower";

export const SubscribeForm = ({ followersConfig, isIntroPage }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [error, setError] = useState("");

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setIsValidEmail(validateEmail(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail) {
      setIsSubmitted(false);
      setError("Please enter a valid email address.");
      setEmail("");
      return;
    }

    try {
      await addFollower(
        name,
        email,
        followersConfig.sheetName,
        followersConfig.followersScriptUrl
      );

      setIsSubmitted(true);
      setName("");
      setEmail("");
      setError("");
    } catch (error) {
      setError("An error occurred while subscribing. Please try again later.");
      console.error("Error:", error);
    }
  };

  if (isIntroPage) {
    return null;
  }

  return (
    <div className="subscribe">
      {isSubmitted && (
        <p className="flex-center" style={{ color: "white" }}>
          Form submitted successfully!
        </p>
      )}
      {error && (
        <p className="flex-center" style={{ color: "white" }}>
          {error}
        </p>
      )}
      <div>
        <form onSubmit={handleSubmit} className="subscribe-form">
          <PageTitle
            className="btn-shine "
            pageTitle={"SUBSCRIBE TO NEWSLETTER"}
          />
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
            autoComplete="email"
          />
          <button
            type="submit"
            aria-label="Subscribe"
            className="subscribe-btn shadow-img"
          >
            <div className="subscribe-btn-text">SUBSCRIBE</div>
          </button>
        </form>
      </div>
    </div>
  );
};
